/** Separator between customer number and name in the dealer search field (display only). */
export const DEALER_INPUT_DISPLAY_SEP = ' — ';

/** Strip the display name; only the customer number segment is used for search and lookup. */
export function extractCustomerNumberPart(value: string): string {
	const t = value.trim();
	const i = t.indexOf(DEALER_INPUT_DISPLAY_SEP);
	return (i >= 0 ? t.slice(0, i) : t).trim();
}

/**
 * Normalizes dealer customer number for API lookup:
 * - If the field shows "CUST — Name", only the CUST segment is used.
 * - If it already matches C + exactly six digits (7 chars total), return as-is.
 * - If it starts with C and is shorter than 7 characters, pad the numeric part with leading zeros to six digits after C.
 * - If it does not start with C, prepend C and pad the digit run to six digits after C.
 */
export function normalizeCustomerNumberForLookup(value: string): string {
	const idPart = extractCustomerNumberPart(value);
	if (!idPart) return '';

	if (/^C\d{6}$/i.test(idPart)) {
		return `C${idPart.slice(1)}`;
	}

	let digits: string;
	if (/^c/i.test(idPart)) {
		digits = idPart.slice(1).replace(/\D/g, '');
	} else {
		digits = idPart.replace(/\D/g, '');
	}
	if (!digits) {
		return idPart;
	}
	const six = digits.length > 6 ? digits.slice(-6) : digits.padStart(6, '0');
	return `C${six}`;
}

export function formatDealerInputDisplay(customerNumber: string, customerName: string): string {
	const num = customerNumber.trim();
	const name = customerName.trim();
	if (!num) return '';
	if (!name) return num;
	return `${num}${DEALER_INPUT_DISPLAY_SEP}${name}`;
}
